// Botão "Voltar" dos chats — grande e sempre visível, para a criança sair
// do chat com UM toque (antes, o chat era um beco sem saída).
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const Botao = styled.button.attrs({ type: 'button' })`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  background: #fff;
  color: var(--jk-text, #263238);
  border: 2px solid rgba(0, 0, 0, 0.12);
  border-radius: 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

  font-size: 16px;
  font-weight: bold;
  min-height: 48px;
  padding: 0 18px;
  margin: 10px 0 4px 10px;

  cursor: pointer;
  touch-action: manipulation;
  transition: transform 0.1s ease, background 0.15s ease;

  &:hover { background: #f2f6f9; }
  &:active { transform: scale(0.96); }

  span { font-size: 20px; }
`;

export default function VoltarChat({ para }) {
  const history = useHistory();
  return (
    <Botao onClick={() => history.push(para || '/dashboard')} aria-label="Voltar">
      <span aria-hidden="true">⬅</span> Voltar
    </Botao>
  );
}
